<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name" #title>ユーザ情報設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">ユーザ区分</label>
          <div class="list-input-content">
            <select id="cmb_userType" class="combo-box-required" [(ngModel)]="kymw9005Model.associatedUserType"
              (change)="eventUserType_CHANGEHandler()">
              <ng-template ngFor let-item [ngForOf]="kymw9005Model.associatedUserTypeList">
                <option value="{{item.associatedUserType}}">{{item.associatedUserTypeName}}</option>
              </ng-template>
            </select>
          </div>

          <label class="list-input-title">所属</label>
          <div class="list-input-content">
            <div class="element-row">
              <input type="text" id="tbx_associatedCompanyName" class="text-label-required" readonly
                [(ngModel)]="kymw9005Model.associatedCompanyName" (input)="eventEditHandler()">
              <button id="btn_SearchOrdrClient" [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
                (click)="eventSearchAssociatedCompany_CLICKHandler()">検索</button>
            </div>
          </div>

          <label class="list-input-title">氏名(漢字)</label>
          <div class="list-input-content">
            <div class="list-input-content">
              <app-not-null-text-input id="tbx_associatedUserName" 
                [restrict]="'[ -￮]'" [maxChars]="20" [width]="'22rem'"
                [(ngModel)]="kymw9005Model.associatedUserName" [displayCountField]="false"
                (input)="eventEditHandler()">
              </app-not-null-text-input>
            </div>
          </div>

          <label class="list-input-title">氏名(かな)</label>
          <div class="list-input-content">
            <div class="list-input-content">
              <app-not-null-text-input id="tbx_associatedUserNameKana" 
                [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true" [width]="'22rem'"
                [(ngModel)]="kymw9005Model.associatedUserNameKana" [displayCountField]="false"
                (input)="eventEditHandler()">
              </app-not-null-text-input>
            </div>
          </div>

          <label class="list-input-title">メールアドレス</label>
          <div class="list-input-content">
            <app-not-null-text-input id="txt_emailAdress" [maxChars]="256" [(ngModel)]="kymw9005Model.emailAddress"
              [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.]'" (input)="eventEditHandler()"
              [disabled]="txt_emailAdressDisabled" [displayCountField]="false">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">権限</label>
          <div class="list-input-content">
            <select id="select_authority" class="combo-box-required" [(ngModel)]="kymw9005Model.authoritySetId"
              (change)="eventEditHandler()">
              <ng-template ngFor let-item [ngForOf]="kymw9005Model.authoritySetList">
                <option value="{{item.authoritySetId}}">{{item.authoritySetName}}</option>
              </ng-template>
            </select>
          </div>

          <label class="list-input-title">有効/無効</label>
          <div class="list-input-content">
            <app-radio-label [(ngModel)]="kymw9005Model.isEnabled" label="有効" value="0" (change)="eventEditHandler()"
              name="grp_isEnabled">
            </app-radio-label>
            <app-radio-label [(ngModel)]="kymw9005Model.isEnabled" label="無効" value="1" (change)="eventEditHandler()"
              name="grp_isEnabled">
            </app-radio-label>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" [tabindex]="0" (click)="eventRegistUser_CLICKHandler()">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>